import {
    removeCookie,
    retrieveCookie,
    storeCookie,
} from '../data/cookies/cookies'
import { DataLayerEventName } from '../helpers/DataLayerEventName'
import {
    BreachEvent,
    BreachEventNameType,
    BreachScreenType,
} from './breach-event-types'

export const breachStateCookie = 'breach_state'

export interface BreachState {
    breachScreenType?: BreachScreenType
    eventType: BreachEventNameType
}

export function setBreachState(event: BreachEvent | undefined) {
    if (!event || !event?.payload?.breachScreenType) {
        removeCookie(breachStateCookie)
    } else {
        const cookie: BreachState = {
            breachScreenType: event.payload.breachScreenType,
            eventType: event.type,
        }
        storeCookie(breachStateCookie, cookie)
    }
}

export function getBreachState() {
    return retrieveCookie<BreachState>(breachStateCookie)
}

/**
 * Block breach events if they don't follow the Avaliable -> Click -> Complete flow (for the same breach screen type)
 */
export function blockBreachEvent(event: BreachEvent) {
    const state = getBreachState()

    // Block completion if no previous state
    if (!state) {
        return event.type === DataLayerEventName.breachScreenComplete
    }
    // Allow different breach screen to update state
    if (state.breachScreenType !== event.payload.breachScreenType) {
        return false
    }
    // Don't allow Click -> Available
    if (event.type === DataLayerEventName.breachScreenAvailable) {
        return state.eventType === DataLayerEventName.breachScreenClick
    }
    // Require Click -> Complete
    if (event.type === DataLayerEventName.breachScreenComplete) {
        return state.eventType !== DataLayerEventName.breachScreenClick
    }

    return false
}
